export { WaitingListComponent } from '../components/waiting-list/waiting-list.component';
